module.exports = __webpack_public_path__ + "img/norimichi-system3.ad235570.png";